import { render } from "./PatientsDatatableTDTeeth.vue?vue&type=template&id=46315f90"
import script from "./PatientsDatatableTDTeeth.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDTeeth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__